import AppSettings from "../AppSettings";

const CLIPART_IMAGE_TYPE = "Clip Art";
const LOGO_IMAGE_TYPE = "Logo";
const OVERLAY_TYPE = 'Overlay'
const SIGNATURE_IMAGE_TYPE = "Signature";
const STANDARD_IMAGE_TYPE = "Standard";
const signatureGalleryArr = [
  {
    Id: 3,
    Locked: false,
    Name: "My Signature Image",
    images: [],
    ImageType: SIGNATURE_IMAGE_TYPE,
  },
];

import * as api from "../net/api";

let singletonInstance = null;

class GalleryManager {
  constructor() {
    if (!singletonInstance) {
      // If null, set singletonInstance to this Class
      singletonInstance = this;
      this.isClipArtEnabled = false;
    }

    return singletonInstance;
  }

  loadGalleries(galleryUrl) {
    return new Promise((resolve, reject) => {
      api.getDataByUrl(galleryUrl).then((data) => {
        if (!data) {
          return;
        }

        let count = 0;

        this.galleries = data;

        for (const gallery of this.galleries) {
          if (gallery.ImageType === CLIPART_IMAGE_TYPE) {
            this.isClipArtEnabled = true;
          }

          api.getDataByUrl(gallery.Url).then((data) => {
            gallery.images = data.Images;
            // console.log(gallery);

            count++;

            if (count === this.galleries.length) {
              // all galleries has been loaded
              if (!this.selectedGalleryId) {
                const standartGalleries = this.getStandardImages();
                if (standartGalleries.length > 0) {
                  this.selectedGalleryId = standartGalleries[0].Id;
                }
              }
              // console.log('galleries', this.galleries);

              resolve();
            }
          });
        }
      });
    });
  }

  getGalleryPriceCodeById(galleryId) {
    const selectedGallery = this.galleries.filter((item) => item.Id == galleryId);
    return selectedGallery.map((item) => item.PriceCode)[0];
  }

  hasCliparts() {
    return this.isClipArtEnabled;
  }

  getClipArts() {
    return this.galleries.filter((el) => el.ImageType === CLIPART_IMAGE_TYPE);
  }

	getSignatureImages() {
		return signatureGalleryArr[0].images;
	};

	getOverlayImages(){
		return this.galleries.filter(el => el.ImageType == OVERLAY_TYPE)
	}

  getLogoImages() {
    return this.galleries.filter((el) => el.ImageType === LOGO_IMAGE_TYPE);
  }

  getStandardImages() {
    return this.galleries.filter((el) => el.ImageType === STANDARD_IMAGE_TYPE);
  }

  getSelectedGallery() {
    let images = [];
    if (this.selectedGalleryId) {
      // find selected gallery
      const selectedGallery = this.galleries.find(
        (el) => el.Id === this.selectedGalleryId
      );
      if (selectedGallery) {
        images = selectedGallery.images;
        if (selectedGallery.Locked) {
          [...images].forEach((img) => (img.Locked = true));
        }
      }
    }
    return images;
  }

  // Fetch All galleries
  getAllGalleries() {
    const images = [];

    // fetch all galleries and images
    for (const gallery of this.galleries) {
      const imgs = gallery.images;
      for (const img of imgs) {
        images.push(img);
      }
    }

    [...images].forEach((img) => (img.Locked = true));

    return images;
  }

  getImageById(id) {
    let image = null;
    for (const gallery of this.galleries) {
      image = gallery.images.find((img) => img.Id === id);

      if (image) {
        break;
      }
    }

    return image;
  }

  setFavesMode(favesMode) {
    this.favesMode = favesMode;
  }

  getFavesMode() {
    return this.favesMode || false;
  }

  //catId is id of image's originating category
  addFavouriteImage(catId, imageId, imageUrl, locked, liked) {
    const originatingGallery = this.galleries.find(
      (gallery) => gallery.Id === catId
    );

    // check if favourites gallery exists
    let favesGallery = this.galleries.find((gallery) => gallery.Id === 99);

    if (!favesGallery) {
      favesGallery = {
        Id: 99,
        Locked: false,
        Name: "Favourites",
        images: [],
        ImageType: STANDARD_IMAGE_TYPE,
      };
      this.galleries.unshift(favesGallery);
    }

    favesGallery.images.push({
      CatId: catId,
      Id: imageId,
      LargeImage: imageUrl,
      Locked: locked,
      Liked: liked,
      tallARatio: false,
    });
  }

  removeFavouriteImage(imageId) {
    const favesGallery = this.galleries.find((gallery) => gallery.Id === 99);
    const thisImg = favesGallery.images.find(
      (imgElement) => imgElement.Id == imageId
    );

    const originatingGallery = this.galleries.find(
      (gallery) => gallery.Id === thisImg.CatId
    );
    const origImg = originatingGallery.images.find(
      (imgElement) => imgElement.Id == imageId
    );

    origImg.Liked = false;

    favesGallery.images.splice(
      favesGallery.images.findIndex(({ Id }) => Id == imageId),
      1
    ); //remove image from favourites gallery

    if (favesGallery.images.length === 0) {
      this.galleries.splice(favesGallery, 1); //remove gallery from galleries list
    }
  }

  addCustomImage(imageId, imageUrl, tallAspect) {
    let customGallery;

    if (this.galleries) {
      customGallery = this.galleries.find((gallery) => gallery.Id === 1);
    } else {
      this.galleries = [];
    }

    // check if custom gallery exists
    if (!customGallery) {
      customGallery = {
        Id: 1,
        Locked: false,
        Name: AppSettings.Language.myImages,
        images: [],
        ImageType: STANDARD_IMAGE_TYPE,
      };
      this.galleries.unshift(customGallery);
    }

    customGallery.images.push({
      Id: imageId,
      LargeImage: imageUrl,
      Locked: false,
      tallARatio: tallAspect,
    });
    this.selectedGalleryId = 0;
  }

  createSignatureGallery(imageId, imageUrl) {
    signatureGalleryArr[0].images = [];
    signatureGalleryArr[0].images.push({
      Id: imageId,
      LargeImage: imageUrl,
      Locked: false,
    });
    this.selectedGalleryId = 3;
  }

  addLogoImage(imageId, imageUrl) {
    // check if custom gallery exists
    let logoGallery = this.galleries.find((gallery) => gallery.Id === 2);

    if (!logoGallery) {
      logoGallery = {
        Id: 2,
        Locked: false,
        Name: "My Logo Image",
        images: [],
        ImageType: LOGO_IMAGE_TYPE,
      };
      this.galleries.unshift(logoGallery);
    }

    logoGallery.images.push({
      Id: imageId,
      LargeImage: imageUrl,
      Locked: false,
    });
    this.selectedGalleryId = 2;
  }
}

export default GalleryManager;
